import { render } from "./ListeParentPage.vue?vue&type=template&id=307a6b73&ts=true"
import script from "./ListeParentPage.vue?vue&type=script&lang=ts"
export * from "./ListeParentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__